/*
 * @Author: 常朵
 * @Date: 2022-05-26 16:22:23
 * @Descripttion: 
 * @LastEditTime: 2022-05-26 16:47:39
 * @version: 
 */
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            redirect: '/index'
        },
        { // 场景-主页
            path: '/index',
            component: resolve => require(['../page/sence/index.vue'], resolve)
        },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js